import baseUrl from './base';

export const deleteRecus = () => `${baseUrl}/parametrages/recus`;

export const deleteFactures = () => `${baseUrl}/parametrages/factures`;
export const createFactures = () => `${baseUrl}/parametrages/factures`;

export const updateCycles = () => `${baseUrl}/parametrages/cycles`;

export const incorporationFlux = () => `${baseUrl}/cycles/integration`;
export const incorporationFluxContrat = () => `${baseUrl}/contrats/integration`;
